<script lang="ts" module>
  import type { Snippet } from 'svelte';
  import type { SystemStyleObject } from '@agapi/ui/panda/types';
</script>

<script lang="ts">
  import { usePopoverContext, usePopoverOptionsContext } from '../use-popover-context';
  import { popoverStyles } from '../popover-styles';
  import { css } from '@agapi/ui/panda/css';
  import type { PopoverContentProps } from '../popover.types';

  const popover = usePopoverContext();
  const options = usePopoverOptionsContext();

  const { children, css: cssProp, onmouseenter, onmouseleave }: PopoverContentProps = $props();

  const classes = popoverStyles.raw();
</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<!-- svelte-ignore attribute_global_event_reference -->
<div
  {...popover.api.getContentProps()}
  {onmouseenter}
  {onmouseleave}
  class={css(classes.content, cssProp)}
>
  {#if children}
    {@render children()}
  {/if}
</div>
